/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.addEventListener('DOMContentLoaded', () => {
    let swipersCollection = [];

    const initSwipers = () => {
      if (window.innerWidth >= 768) {
        document.querySelectorAll('.tab-collections-swiper.swiper-container').forEach((container, index) => {
          if (!swipersCollection[index]) {
            swipersCollection[index] = new Swiper(container, {
              pagination: {
                  el: '.swiper-pagination',
                  clickable: true,
              },
              navigation: {
                nextEl: '.tab-collections-swiper.swiper-container > .swiper-button-next',
                prevEl: '.tab-collections-swiper.swiper-container > .swiper-button-prev',
              },
              slidesPerView: 1,
              spaceBetween: 10,
              breakpoints: {
                  750: {
                      slidesPerView: 3,
                      spaceBetween: 4,
                  },
              },
            });
          }
        });
      } else {
        swipersCollection.forEach((swiper, index) => {
          if (swiper) {
            swiper.destroy(true, true);
            swipersCollection[index] = null;
            // Reset the slides layout after destroying swiper
            document.querySelectorAll('.tab-collections-swiper .swiper-slide').forEach(slide => {
                slide.style.width = '';
            });
          }
        });
      }
    };

    const theLookSlider = () => {
      const swiperContainer = document.querySelector('.the-look-swiper');
      const slidesPerView = swiperContainer.getAttribute('data-slides-per-view');
      new Swiper('.the-look-swiper', {
        slidesPerView: 1.3,
        spaceBetween: 8,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            // when window width is >= 640px
            640: {
                slidesPerView: parseInt(slidesPerView, 10),
                spaceBetween: 24
            }
        }
      });
    }

    const onSectionLoad = () => {
      initSwipers();
      theLookSlider();
      window.addEventListener('resize', initSwipers);
    };

    const onSectionUnload = () => {
      initSwipers();
      theLookSlider();
      swipersCollection.forEach((swiper, index) => {
        if (swiper) {
            swiper.destroy(true, true);
            swipersCollection[index] = null;
        }
      });
      window.removeEventListener('resize', initSwipers);
    };

    // Initialize Swiper on load
    initSwipers();
    theLookSlider();

    // Re-initialize Swiper on window resize
    window.addEventListener('resize', initSwipers);

    // Shopify Section Events
    document.addEventListener('shopify:section:load', onSectionLoad);
    document.addEventListener('shopify:section:unload', onSectionUnload);
    document.addEventListener('shopify:section:select', onSectionLoad);
    document.addEventListener('shopify:section:deselect', onSectionUnload);
    document.addEventListener('shopify:block:select', onSectionLoad);
    document.addEventListener('shopify:block:deselect', onSectionUnload);
    document.addEventListener('shopify:block:load', onSectionLoad);
    document.addEventListener('shopify:block:unload', onSectionUnload);

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      onSectionLoad();
    }
  });
  
  function applyAccordionBehavior() {
    document.querySelectorAll('.section-sidebar-custom .section-sidebar__title').forEach(function(label) {
      label.addEventListener('click', function() {
        label.classList.toggle('open');
        label.querySelectorAll('.icon').forEach(function(child) {
          child.classList.toggle('show');
        });
  
        var nextElement = label.nextElementSibling;
        if (label.classList.contains('open')) {
          while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
            nextElement.classList.add('open-accordion');
            nextElement = nextElement.nextElementSibling;
          }
        } else {
          while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
            nextElement.classList.remove('open-accordion');
            nextElement = nextElement.nextElementSibling;
          }
        }
      });
    });
  }
  
  function removeAccordionBehavior() {
    document.querySelectorAll('.section-sidebar__title').forEach(function(label) {
      label.removeEventListener('click', toggleAccordion);
    });
  }
  
  function toggleAccordion(event) {
    var label = event.currentTarget;
    label.classList.toggle('open');
    label.querySelectorAll('.icon').forEach(function(child) {
      child.classList.toggle('show');
    });
  
    var nextElement = label.nextElementSibling;
    if (label.classList.contains('open')) {
      while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
        nextElement.classList.add('open-accordion');
        nextElement = nextElement.nextElementSibling;
      }
    } else {
      while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
        nextElement.classList.remove('open-accordion');
        nextElement = nextElement.nextElementSibling;
      }
    }
  }
  
  function updateAccordionBehavior() {
    if (window.matchMedia('(max-width: 750px)').matches) {
      applyAccordionBehavior();
    } else {
      removeAccordionBehavior();
    }
  }
  updateAccordionBehavior();
  window.addEventListener('resize', updateAccordionBehavior);
  
  function applyAccordionBehavior() {
    document.querySelectorAll('.section-sidebar-custom .section-sidebar__title').forEach(function(label) {
      label.addEventListener('click', function() {
        label.classList.toggle('open');
        label.querySelectorAll('.icon').forEach(function(child) {
          child.classList.toggle('show');
        });
  
        var nextElement = label.nextElementSibling;
        if (label.classList.contains('open')) {
          while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
            nextElement.classList.add('open-accordion');
            nextElement = nextElement.nextElementSibling;
          }
        } else {
          while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
            nextElement.classList.remove('open-accordion');
            nextElement = nextElement.nextElementSibling;
          }
        }
      });
    });
  }
  
  function removeAccordionBehavior() {
    document.querySelectorAll('.section-sidebar__title').forEach(function(label) {
      label.removeEventListener('click', toggleAccordion);
    });
  }
  
  function toggleAccordion(event) {
    var label = event.currentTarget;
    label.classList.toggle('open');
    label.querySelectorAll('.icon').forEach(function(child) {
      child.classList.toggle('show');
    });
  
    var nextElement = label.nextElementSibling;
    if (label.classList.contains('open')) {
      while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
        nextElement.classList.add('open-accordion');
        nextElement = nextElement.nextElementSibling;
      }
    } else {
      while (nextElement && !nextElement.classList.contains('section-sidebar__title')) {
        nextElement.classList.remove('open-accordion');
        nextElement = nextElement.nextElementSibling;
      }
    }
  }
  
  function updateAccordionBehavior() {
    if (window.matchMedia('(max-width: 750px)').matches) {
      applyAccordionBehavior();
    } else {
      removeAccordionBehavior();
    }
  }
  updateAccordionBehavior();
  window.addEventListener('resize', updateAccordionBehavior);

  /** 23 May 2025 - MILQ */
    const shownHandles = new Set();
    
    function getTargetSize() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('filter.v.option.size')?.toLowerCase() || null;
    }
    
    // Check if any filter is active in the URL
    function hasActiveFilters() {
      const urlParams = new URLSearchParams(window.location.search);
      for (const [key, value] of urlParams.entries()) {
        if (key.startsWith('filter.v.option.') && value.trim() !== '') {
          return true;
        }
      }
      return false;
    }
    
    // Check if a size exists in a comma separated sizes string
    function hasSize(sizesStr, size) {
      if (!sizesStr || !size) return false;
      return sizesStr.toLowerCase().split(',').map(s => s.trim()).includes(size);
    }
    
    function applyFilterInGrid() {
      const size = getTargetSize();
      const grid = document.querySelector('#CollectionLoop');
      const pagination = document.querySelector('.pagination-custom');
      const loadMoreBtn = document.getElementById('LoadMoreBtn');
    
      if (!grid) return false;
    
      const filtersActive = hasActiveFilters();
    
      // Show or hide pagination and Load More button
      if (filtersActive) {
        if (pagination) pagination.style.display = 'none';
        if (loadMoreBtn) loadMoreBtn.style.display = 'inline-block';
      } else {
        if (pagination) pagination.style.display = '';
        if (loadMoreBtn) loadMoreBtn.style.display = 'none';
      }
    
      if (!size) {
        // No size filter, just keep all products visible & track handles
        shownHandles.clear();
        grid.querySelectorAll('.product-item').forEach(card => {
          const handle = card.getAttribute('data-product-handle');
          if (handle) shownHandles.add(handle);
        });
        return true;
      }
    
      // Size filter is present: filter cards that don't have the size
      shownHandles.clear();
      const cards = grid.querySelectorAll('.product-item');
      cards.forEach(card => {
        const sizes = card.getAttribute('data-available-sizes');
        const handle = card.getAttribute('data-product-handle');
        if (!hasSize(sizes, size)) {
          card.remove();
        } else if (handle) {
          shownHandles.add(handle);
        }
      });
    
      return grid.querySelectorAll('.product-item').length > 0;
    }
    
    async function loadNextFilteredPage() {
      // Only load more when filters active
      if (!hasActiveFilters()) {
        return false;
      }
    
      const btn = document.getElementById('LoadMoreBtn');
      if (!btn) return false;
    
      const currentPage = parseInt(btn.dataset.page || '1');
      const nextPage = currentPage + 1;
    
      const url = new URL(window.location.href);
      url.searchParams.set('page', nextPage);
    
      try {
        const res = await fetch(url.toString());
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCards = doc.querySelectorAll('.product-item');
    
        if (newCards.length === 0) {
          btn.style.display = 'none'; // No more products to load
          return false;
        }
    
        const grid = document.querySelector('#CollectionLoop');
        let added = 0;
    
        newCards.forEach(card => {
          const handle = card.getAttribute('data-product-handle');
          const sizes = card.getAttribute('data-available-sizes');
          const size = getTargetSize();
    
          // Add only if not already shown & matches size if size filter applied
          if (
            handle &&
            !shownHandles.has(handle) &&
            (!size || hasSize(sizes, size))
          ) {
            grid.appendChild(card);
            shownHandles.add(handle);
            added++;
          }
        });
    
        if (added === 0) {
          btn.style.display = 'none'; // Hide if no new products appended
          return false;
        }
    
        btn.dataset.page = nextPage.toString();
        return true;
      } catch (err) {
        console.error('Load More Failed:', err);
        return false;
      }
    }
    
    function setupLoadMoreButton() {
      const btn = document.getElementById('LoadMoreBtn');
      if (btn) {
        btn.removeEventListener('click', loadNextFilteredPageHandler);
        btn.addEventListener('click', loadNextFilteredPageHandler);
      }
    }
    
    function loadNextFilteredPageHandler(event) {
      event.preventDefault();
      loadNextFilteredPage();
    }
    
    async function applyFiltersWithLoadMore(autoLoadLimit = 5) {
      const filteredHasProducts = applyFilterInGrid();
      setupLoadMoreButton();
    
      const grid = document.querySelector('#CollectionLoop');
      if (!grid) return;
    
      if (!filteredHasProducts) {
        let tries = 0;
        let loadedAny = false;
        do {
          tries++;
          loadedAny = await loadNextFilteredPage();
        } while (loadedAny && tries < autoLoadLimit && grid.querySelectorAll('.product-item').length === 0);
      }
    
      const btn = document.getElementById('LoadMoreBtn');
      if (btn && grid.querySelectorAll('.product-item').length === 0) {
        btn.style.display = 'none';
      }
    }
    
    function waitForProducts(callback, retries = 20) {
      const grid = document.querySelector('#CollectionLoop');
      if (grid && grid.querySelectorAll('.product-item').length > 0) {
        callback();
      } else if (retries > 0) {
        setTimeout(() => waitForProducts(callback, retries - 1), 250);
      }
    }
    
    document.addEventListener('DOMContentLoaded', () => {
      waitForProducts(applyFiltersWithLoadMore);
    });
    
    const bodyObserver = new MutationObserver(() => {
      waitForProducts(applyFiltersWithLoadMore);
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
